import styled from 'styled-components';
import { config } from '../../../../components/dashboards/config';

export default styled.div`
  overflow: hidden;
  width: calc(100% - ${config.PADDING * 2}px);
  margin-left: ${config.PADDING}px;
  height: 402px;

  .table {
    margin-bottom: 0px;
  }

  .loading-cont {
    height: 400px;
    position: relative;
  }

  .ant-table-container {
    height: 400px;
    overflow-y: auto;

    .ant-table-thead {
      .ant-table-cell {
        background: #F5F5F5 !important;
      }
    }
  }

  .content-centered {
    display: flex;
    justify-content: center;
  }

  .expanded-table-cell {
    .ant-table-cell {
      padding: 0px;
    }
  }

  .active-row {
    td {
      background: #DCEEFF !important;
    }
  }

  .no-header-table {
    .ant-table-container {
      height: unset;
    }
  }
`;
export const TooltipStyle = styled.div`
  padding: 10px 4px;

  h4 {
    color: #BDBDBD;
    font-weight: 300;
    font-size: 14px;
  }

  p {
    margin-bottom: 0px;
    font-size: 14px;
  }
`;
